module.exports = __webpack_public_path__ + "static/media/popup_close.bacf01f5.svg";